class PageModeEnum {
	static NEW = "NEW";
	static EDIT = "EDIT"
}

class EntityTypesEnum {
	static SALE_STATUS = "saleStatus"
}

class FormatTypeModifiersEnum {
	static NO_UNIT_SIGN = 1
}

class DocumentTypeEnum {
	static NATIONAL_ID = 1;
	static REGISTERED_NUMBER = 2
}

class ButtonStateEnum {
	static DISABLED = 1;
	static ENABLED = 2;
	static HIDDEN = 3;
}

class PaymentMethodsEnum {
	static CASH = 1;
	static CREDIT_CARD = 2;
	static DEBIT_CARD = 3;
	static WIRE_TRANSFER = 4;
	static CHECK = 5;
	static OTHERS = 6;
}

class InvoiceStatusEnum {
	static CREATED = 1;
	static VALIDATED = 2;
	static EMMITED = 3;
	static EMMISSION_ERROR = 4;
	static CANCELLED = 5;
}

class ProductStatusIdEnum {
	static ACTIVATED = 1;
	static DEACTIVATED = 2;
}

class FormatTypeEnum {
	static CURRENCY = 'currency';
	static CURRENCY_AND_PERCENTAGE = 'currency-and-percentage';
	static DECIMAL = 'decimal';
	static INTEGER = 'integer';
	static PERCENTAGE = 'percentage';
	static SHORT_DATE = 'short-date';
	static SHORT_DATE_TIME = 'short-date-time';
	static DATE_TIME = 'date-time';
	static DATE = 'date';
	static TEXT = 'text';
	static BOOLEAN = 'boolean';
	static LIST = 'list';
}

class AlertType {
	static SUCCESS = {
		toastIcon: 'fa fa-check text-success',
		toastClass: 'text-bg-success'
	}
	static WARNING = {
		toastIcon: 'fa fa-warning text-warning',
		toastClass: 'text-bg-warning'
	}
	static ERROR = {
		toastIcon: 'fa fa-circle-exclamation text-danger',
		toastClass: 'text-bg-error'
	}
}

class ApiRowCountEnum {
	static TABLE = 100
}

class ResultCodeEnum {
	static DUPLICATE_POST = "DUPLICATE_POST";
	static SUCCESS = "SUCCESS"
}

class Languages {
	static TableDefault = {
		"decimal": "",
		"emptyTable": "Nenhum dado disponível na tabela",
		"info": "Mostrando registros de _START_ a _END_ de _TOTAL_",
		"infoEmpty": "Mostrando registros de 0 a 0 de 0",
		"infoFiltered": "(Filtrado de _MAX_ registros totais)",
		"infoPostFix": "",
		"thousands": ",",
		"lengthMenu": "Mostrar _MENU_ registro(s)",
		"loadingRecords": "Carregando...",
		"processing": "",
		"search": "Pesquisar:",
		"zeroRecords": "Nenhum registro encontado",
		"paginate": {
			"first": "Primeiro",
			"last": "Último",
			"next": "Próximo",
			"previous": "Anterior"
		},
		"aria": {
			"sortAscending": ": activate to sort column ascending",
			"sortDescending": ": activate to sort column descending"
		}
	}
}

class SaleStatusItem {
}

class SaleStatusEnum {
	static PENDING_CREATION = 0;
	static CREATED = 1;
	static PERFORMED = 2;
	static INVOICE_PENDING = 3;
	static INVOICED = 4;
	static CANCELLED = 5;
	static ALREADY_SELECTED = -1;
}

class InvoiceStatusEnumMapper {
	static mapInvoiceStatusDescription(invoiceStatusId) {
		switch (invoiceStatusId) {
			default:
			case InvoiceStatusEnum.CREATED:
				return "Criado";
			case InvoiceStatusEnum.EMMITED:
				return "Emitido";
			case InvoiceStatusEnum.EMMISSION_ERROR:
				return "Erro na Emissão";
			case InvoiceStatusEnum.CANCELLED:
				return "Cancelado";
		}
	}

	static mapInvoiceStatusBadgeStyle(invoiceStatus) {
		switch (invoiceStatus) {
			case InvoiceStatusEnum.CREATED:
				return "text-bg-info";
			case InvoiceStatusEnum.EMMITED:
				return "text-bg-success";
			case InvoiceStatusEnum.EMMISSION_ERROR:
			case InvoiceStatusEnum.CANCELLED:
				return "text-bg-danger";
		}
	}
	static mapInvoiceStatusOption(invoiceStatus) {
		return {description: this.mapInvoiceStatusDescription(invoiceStatus), badgeStyle: this.mapInvoiceStatusBadgeStyle(invoiceStatus)};
	}
}

class InvoiceGenerationStatusEnum {
	static CREATED = 1;
	static RESERVED = 2;
	static EXECUTING = 3;
	static EXECUTED = 4;
	static ERROR = 5;
}

class QrCodeEntitiesEnum {
        static PRODUCTS = 1;
}

class QrCodeEntitiesEnumMapper {
        static mapDescription(qrCodeEntityId) {
                switch (qrCodeEntityId) {
                        case QrCodeEntitiesEnum.PRODUCTS:
                                return "Produto";
                        default:
                                return "Desconhecido";
                }
        }
}

class InvoiceGenerationStatusEnumMapper {
	static mapInvoiceGenerationStatusDescription(invoiceGenerationStatusId) {
		switch (invoiceGenerationStatusId) {
			default:
			case InvoiceGenerationStatusEnum.CREATED:
				return "Criado";
			case InvoiceGenerationStatusEnum.RESERVED:
			case InvoiceGenerationStatusEnum.EXECUTING:
				return "Executando";
			case InvoiceGenerationStatusEnum.EXECUTED:
				return "Emitido";
			case InvoiceGenerationStatusEnum.ERROR:
				return "Erro na Emissão";
		}
	}

	static mapInvoiceGenerationStatusBadgeStyle(invoiceGenerationStatus) {
		switch (invoiceGenerationStatus) {
			case InvoiceGenerationStatusEnum.CREATED:
				return "text-bg-info";
			case InvoiceGenerationStatusEnum.RESERVED:
			case InvoiceGenerationStatusEnum.EXECUTING:
				return "text-bg-secondary";
			case InvoiceGenerationStatusEnum.EXECUTED:
				return "text-bg-success";
			case InvoiceGenerationStatusEnum.ERROR:
				return "text-bg-danger";
		}
	}
}

class SaleStatusMapper {
	static mapSaleStatusDescription(saleStatusId) {
		switch (saleStatusId) {
			default:
			case SaleStatusEnum.PENDING_CREATION:
				return "Em Criação";
			case SaleStatusEnum.CREATED:
				return "Criado";
			case SaleStatusEnum.PERFORMED:
				return "Finalizado";
			case SaleStatusEnum.INVOICE_PENDING:
				return "Em Emissão";
			case SaleStatusEnum.INVOICED:
				return "Emitido";
			case SaleStatusEnum.CANCELLED:
				return "Cancelado";
			case SaleStatusEnum.ALREADY_SELECTED:
				return "Selecionado";
		}
	}

	static mapSaleStatusBadgeStyle(saleStatus) {
		switch (saleStatus) {
			case SaleStatusEnum.PENDING_CREATION:
			case SaleStatusEnum.CREATED:
			case SaleStatusEnum.PERFORMED:
			case SaleStatusEnum.INVOICE_PENDING:
			case SaleStatusEnum.INVOICED:
				return "text-bg-success";
			case SaleStatusEnum.CANCELLED:
				return "text-bg-danger";
			case SaleStatusEnum.ALREADY_SELECTED:
				return "text-bg-warning";
		}
	}
}

export {
        PageModeEnum,
        Languages,
        ResultCodeEnum,
        ApiRowCountEnum,
        FormatTypeEnum,
        AlertType,
        EntityTypesEnum,
        SaleStatusEnum,
        FormatTypeModifiersEnum,
        PaymentMethodsEnum,
        DocumentTypeEnum,
        ButtonStateEnum,
        ProductStatusIdEnum,
        SaleStatusMapper,
        InvoiceStatusEnumMapper,
        InvoiceStatusEnum,
        InvoiceGenerationStatusEnum,
        InvoiceGenerationStatusEnumMapper,
        QrCodeEntitiesEnum,
        QrCodeEntitiesEnumMapper
};
